
export const listenTo = ( ioChannel, ioMethod, callbacks ) => {
	if ( callbacks.invoked ) {
		ioChannel.subscribe( `${ ioMethod }.invoked`, callbacks.invoked );
	}

	if ( callbacks.success ) {
		ioChannel.subscribe( `${ ioMethod }.success`, callbacks.success );
	}

	ioChannel.subscribe( `${ ioMethod }.error`, ( ...args ) => {
		// eslint-disable-next-line no-console
		console.error( "ERROR", `${ ioChannel }.error`, args[ 0 ] );
		if ( callbacks.error ) {
			callbacks.error( ...args );
		}
	} );
};
